import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export const useCreateApplicationForShopper = () => {
  const [isCreating, setIsCreating] = useState(false);

  const createApplicationForShopper = async (
    shopperEmail: string,
    peoProviderId: string
  ) => {
    setIsCreating(true);
    try {
      const { data, error } = await supabase.rpc(
        'create_application_for_shopper',
        {
          p_shopper_email: shopperEmail,
          p_created_by_peo_id: peoProviderId
        }
      );

      if (error) throw error;

      toast.success(
        'Application created successfully. The shopper will be notified via email.'
      );
      
      return data; // Returns the application ID
    } catch (error: any) {
      console.error('Error creating application for shopper:', error);
      toast.error('Failed to create application: ' + error.message);
      throw error;
    } finally {
      setIsCreating(false);
    }
  };

  return { createApplicationForShopper, isCreating };
};